import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_recruiting_agency_provide_foreign_migrants_signed'

export const dataPointDefinition = {
  retracedId: 'does_facility_recruiting_agency_provide_foreign_migrants_signed',
  name: 'Does the facility (or recruiting agency) provide foreign migrants with a signed written employment contract prior to lea',
  description:
    'The intent of this question is to understand if foreign migrants sign an employment contract in a language they understand PRIOR TO leaving their home country (also known as "country of origin").',
  meta: {
    slcpMeta: {
      key: 'ep-4',
      number: 'RH-EMP-21',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'ep-4', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27000,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
